import React from 'react'
import { Navigate } from 'react-router-dom'
import { Box, Typography, Alert } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import useAuthStore from '../../store/authStore'

const RoleGuard = ({ 
  children, 
  allowedRoles = [], 
  requireAdmin = false,
  fallback = null,
  redirectTo404 = false 
}) => {
  const { user, isAdmin } = useAuthStore()

  // Check if user has required role
  const hasPermission = () => {
    if (!user) return false
    
    if (requireAdmin) {
      return isAdmin()
    }
    
    if (allowedRoles.length > 0) {
      return allowedRoles.includes(user.role)
    }
    
    return true
  }

  if (!hasPermission()) {
    if (fallback) {
      return fallback
    }

    // If redirectTo404 is true, redirect to a non-existent route to trigger 404
    if (redirectTo404) {
      return <Navigate to="/404-not-found" replace />
    }

    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        p={3}
      >
        <LockIcon color="disabled" sx={{ fontSize: 48, mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Acceso Restringido
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          No tienes permisos suficientes para acceder a esta sección.
        </Typography>
        <Alert severity="info" sx={{ mt: 2, maxWidth: 400 }}>
          Esta funcionalidad requiere permisos de{' '}
          {requireAdmin 
            ? 'Administrador' 
            : allowedRoles.join(' o ')
          }.
        </Alert>
      </Box>
    )
  }

  return children
}

export default RoleGuard
